<template>
  <b-container>
    <b-table
      :fields="fields"
      :items="docs"
      :busy="servicebusy"
      small
      select-mode="single"
      selectable
      selected-variant="info"
      hover
      bordered
      striped
      @row-clicked="selectDocument"
    >
      >
      <template slot="table-busy">
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle" />
          <strong class="mx-2">Laden...</strong>
        </div>
      </template>

      <template #cell(Zi)="row">
        {{ row.item.Zi ? 'Ja' : 'Nee' }}
      </template>

      <template #cell(Da)="row">
        {{ moment(row.item.Da).format("DD.MM.YY") }}
      </template>

      <template #cell(Re)="row">
        {{ row.item.Re }}
      </template>

      <template #cell(Cl)="row">
        <i 
          v-show="row.item.Cl == 1" 
          class="fa fa-cloud"
        />
      </template>

      <template #cell(Ve)="row">
        {{ row.item.Ve ? moment(row.item.Ve).format("DD.MM.YY") : "nb" }}
      </template>

      <template #cell(Un)="row">
        <b-link 
          :href="row.item.Url" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Download document
        </b-link>
      </template>
      
      <template #row-details="data">
        Units: <b-link 
          v-for="u in data.item.Units" 
          :key="u.UnitKenmerk"
          :href="`#/unit/${u.UnitId}`" 
          size="sm"
          variant="outline-primary"
        >
          {{ u.UnitKenmerk }} {{ u.Adres }}
        </b-link>
      </template>
    </b-table>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
  name: "RelatieDocumenten",
  mixins: [serviceMixin],
  props: {
    
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      docs: [],
      fields: [
        "Id",
        { label: "Status", key: "St" },
        { label: "Relatie", key: "Re" },
        { label: "Afzender", key: "Af" },
        { label: "Kenmerk", key: "Ke" },
        { label: "Type", key: "Ty" },
        { label: "Datum", key: "Da" },
        { label: "Bedrag", key: "Be" },
        { label: "Verzenddatum", key: "Ve" },
        { label: "Soort onderhoud", key: "So" },
        { label: "Zichtbaar", key: "Zi" },
        { label: "Unit", key: "Un" },
        { label: "Cloud", key: "Cl" },
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getDocumenten();
  },
  methods: {
    getDocumenten() {
      var id = this.$props.id;
      this.get(`/relatie/${id}/documenten`).then((response) => {
        this.docs = response.data.documenten;
      });
    },
    selectDocument(item) {
      this.$router.push({ name: "Document", params: {id: item.Id }})
    },
  },
}
</script>